import moment from "moment";
import React from "react";

const TimeSlotPlugin = ({ date, slotData, onSelectTime }) => {
    if (!date) return null;
    const selectedDateStr = date.format("YYYY-MM-DDT00:00:00.000Z");

    const slots = Array.isArray(slotData)
        ? slotData.filter((slot) => slot.startDate?.trim() === selectedDateStr)
        : [];

    return (
        <div style={{ padding: "15px", maxHeight: "260px", overflowY: "auto" }}>
            <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                {date.format("dddd, MMMM D")}
            </div>
            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                {slots.map((slot, i) => (
                    <li key={i} style={{ marginBottom: "6px" }}>
                        <button
                            className="btn btn-primary"
                            onClick={() => onSelectTime(slot)}
                            style={{
                                width: "100%",
                                padding: "8px 12px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                        >
                            {moment(slot.startTime).utc().format("hh:mm a")} 
                            {/* - {moment(slot.endTime).utc().format("hh:mm a")} */}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TimeSlotPlugin;
